import { render } from "./PopSicle.vue?vue&type=template&id=2d9b0aec"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/PopSicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d9b0aec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d9b0aec', __exports__)) {
    api.reload('2d9b0aec', __exports__)
  }
  
  module.hot.accept("./PopSicle.vue?vue&type=template&id=2d9b0aec", () => {
    api.rerender('2d9b0aec', render)
  })

}


export default __exports__